import React from 'react';
import { Search } from 'lucide-react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
}
export function Input({
  icon,
  className = '',
  ...props
}: InputProps) {
  return <div className="relative" data-id="element-93">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted" data-id="element-94">
        {icon || <Search size={18} data-id="element-95" />}
      </div>
      <input className={`block w-full pl-10 pr-3 py-2.5 border border-border rounded-xl leading-5 bg-surface text-text placeholder-text-muted focus:outline-none focus:ring-2 focus:ring-primary focus:border-primary sm:text-sm transition-shadow ${className}`} {...props} data-id="element-96" />
    </div>;
}